import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Frame7 from './contactpage';
import Footer from '../../Component/Fooder';

function Frame8() {

  return (
    <>
      <div>
        <Frame7 />
      </div>
      <div className="bg-[#464F60] flex flex-col items-center p-4 lg:p-[151px_58.2px_22px_77px] w-full lg:w-[full] box-border">
        <div className="flex flex-col lg:flex-row w-full lg:w-[fit-content] m-4 lg:m-[0_0_18px_17px] box-border">
          <div className="flex flex-col mb-8 lg:mb-0  lg:mr-[143.3px] box-border">
            <div className=" mx-4 text-start text-[24px] lg:text-[29px] font-bold font-['Plus_Jakarta_Sans']  text-white tracking-wide">
              HIKEHEALTH GS
            </div>
            <span className="mx-4 text-start text-[15px] lg:text-[18px] font-['Plus_Jakarta_Sans'] font-normal text-white leading-relaxed tracking-wide mt-4">
              At HIKEHEALTH GS, we are dedicated to transforming healthcare through innovative IT solutions. <br className="hidden lg:inline" />
              By combining cutting-edge technology with deep healthcare expertise, we enable healthcare providers <br className="hidden lg:inline" />
              to deliver improved patient outcomes, streamline workflows, and enhance the overall patient experience.
            </span>
          </div>
          <div className='flex  justify-around'>
            <div className="flex flex-col  items-center lg:mb-12 lg:mr-[103.4px] box-border">
              <div className="text-[20px] lg:text-[24px] font-['Plus_Jakarta_Sans']  text-white tracking-wide ">
                Company
              </div>
              <div className="flex flex-col text-start mt-9  sm:mb-[11] text-[14px] lg:text-[17px] font-['Plus_Jakarta_Sans']  font-normal text-white leading-relaxed tracking-wide">


                <RouterLink
                  to="/"
                  spy={true}
                  smooth={true}
                  duration={500}
                  className="mb-3 cursor-pointer"
                  activeClass="active"
                >
                  Home
                </RouterLink>
                {/* 
                <RouterLink
                  to="/insights"
                  spy={true}
                  smooth={true}
                  // duration={500}
                  className="mb-3 cursor-pointer"
                  activeClass="active"
                >
                  Insights
                </RouterLink> */}
                <RouterLink
                  to="/About"
                  spy={true}
                  smooth={true}
                  // duration={500}
                  className="mb-3 cursor-pointer"
                  activeClass="active"
                >
                  About us
                </RouterLink>

                <RouterLink
                  to="/Services"
                  spy={true}
                  smooth={true}
                  // duration={500}
                  className="mb-3 cursor-pointer"
                  activeClass="active"
                >
                  Services
                </RouterLink>
                <RouterLink
                  to="/teckstacks"
                  spy={true}
                  smooth={true}
                  // duration={500}
                  className="mb-3 cursor-pointer"
                  activeClass="active"
                >
                  Tech Stacks
                </RouterLink>

                <RouterLink
                  to="/Contact"
                  spy={true}
                  smooth={true}
                  duration={500}
                  className="cursor-pointer mb-3 "
                  activeClass="active"
                >
                  Contact
                </RouterLink>

              </div>
            </div>
            <div className="flex flex-col box-border">
              <div className=" text-start text-[20px] lg:text-[24px] font-['Plus_Jakarta_Sans']  text-white tracking-wide mb-6">
                Contact Info
              </div>
              <div className="text-[14px] lg:text-[17px] font-['Plus_Jakarta_Sans']  font-normal text-white leading-relaxed tracking-wide">
                <div className="mb-6">
                  <div className="font-extrabold  text-start">Address</div>
                  <span className="block mt-1  text-start">
                  Rajapalayam Main Road,Mamsapuram,
                  Srivilliputhur,Virudhunagar(District),<br />
                  TamilNadu - 626110,<br />
                    
                  </span>
                </div>
                <div className="mb-6 text-start">
                  <div className="font-['Plus_Jakarta_Sans']">Phone</div>
                  <a href="tel:+917339055489" className="block mt-1 text-white">
                    +91-7339055489
                  </a>
                </div>

                <div className="flex flex-col text-start text-white">
                  <div className="text-[14px] lg:text-[17px] font-['Plus_Jakarta_Sans'] font-normal leading-relaxed tracking-wide mb-6">
                    <div className="font-bold text-base lg:text-lg">Email</div>
                    <span className="block mt-1 text-[14px] lg:text-[17px]">
                      admin@hikehealthgs.com
                    </span>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="bg-white w-full lg:w-[1262px] h-[1px] mb-8 lg:mb-[35px]"></div>
        {/* <span className="text-[14px] lg:text-[18px] font-['Plus_Jakarta_Sans']  font-normal text-white tracking-wide">
          HIKEHEALTH-GS @ 2025
        </span> */}

      </div>
      <Footer />
    </>
  );
}

export default Frame8;
